// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page wrapper ── */
.exam-page {
  display: flex;
  justify-content: center;
  padding: 24px 16px 64px;
  min-height: 100%;
}

.exam-container {
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Back button ── */
.exam-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #9aa3ad;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  width: fit-content;
  transition: color 0.15s ease;
}
.exam-back:hover { color: #48D1CC; }

/* ── Header ── */
.exam-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.exam-header-icon-wrap {
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 16px;
  background: rgba(59, 179, 174, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}

.exam-header-icon {
  color: #48D1CC !important;
  font-size: 28px !important;
}

.exam-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
}

.exam-subtitle {
  margin: 4px 0 0;
  font-size: 14px;
  color: #9aa3ad;
}

/* ── Progress card ── */
.exam-progress-card {
  background: #0e1b1b;
  border-radius: 16px;
  border: 1px solid #484848;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.exam-progress-top {
  display: flex;
  justify-content: space-between;
}

.exam-progress-label {
  font-size: 14px;
  font-weight: 600;
  color: #e6eaef;
}

.exam-progress-count {
  font-size: 14px;
  font-weight: 700;
  color: #48D1CC;
}

.exam-progress-track {
  width: 100%;
  height: 8px;
  border-radius: 99px;
  background: #071414;
  overflow: hidden;
}

.exam-progress-fill {
  height: 100%;
  border-radius: 99px;
  background: linear-gradient(90deg, #3BB3AE, #48D1CC);
}

/* ── Questions list ── */
.exam-questions-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ── Question card ── */
.exam-question-card {
  background: #0e1b1b;
  border-radius: 16px;
  border: 1px solid #484848;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.exam-question-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.exam-q-num {
  min-width: 32px;
  height: 26px;
  border-radius: 8px;
  background: rgba(59, 179, 174, 0.15);
  color: #48D1CC;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  margin-top: 2px;
  flex-shrink: 0;
}

.exam-q-text {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #e6eaef;
  line-height: 1.5;
}

/* ── Options ── */
.exam-options-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.exam-option {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #071414;
  border: 1.5px solid #484848;
  border-radius: 12px;
  padding: 12px 14px;
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.exam-option:hover:not(:disabled) {
  border-color: rgba(59,179,174,0.35);
  background: #071414;
}

.exam-option:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.exam-option-selected {
  border-color: #3BB3AE !important;
  background: rgba(59, 179, 174, 0.1) !important;
}

.exam-option-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.exam-option-text {
  flex: 1 1;
  font-size: 14px;
  color: #c5cdd6;
  line-height: 1.45;
}

.exam-option-check {
  color: #3BB3AE !important;
  font-size: 18px !important;
  flex-shrink: 0;
}

/* ── Submit bar ── */
.exam-submit-bar {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  margin-top: 8px;
}

.exam-submit-hint {
  margin: 0;
  font-size: 13px;
  color: #9aa3ad;
}

.exam-btn-submit {
  padding: 12px 36px;
  border-radius: 12px;
  border: none;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  background: linear-gradient(135deg, #3BB3AE, #0099a8);
  color: #fff;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.exam-btn-submit:not(:disabled):hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

.exam-btn-submit:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Dialog buttons ── */
.exam-btn-cancel {
  padding: 9px 20px;
  border-radius: 10px;
  border: 1px solid #484848;
  background: transparent;
  color: #9aa3ad;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}
.exam-btn-cancel:hover { border-color: rgba(255,255,255,0.25); color: #e6eaef; }

.exam-btn-confirm {
  padding: 9px 24px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #3BB3AE, #0099a8);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
.exam-btn-confirm:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Error card ── */
.exam-error-card {
  background: #0e1b1b;
  border-radius: 16px;
  border: 1px solid rgba(239, 83, 80, 0.2);
  padding: 40px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #9aa3ad;
  text-align: center;
}

.exam-btn-secondary {
  margin-top: 8px;
  padding: 10px 24px;
  border-radius: 12px;
  border: 1px solid #484848;
  background: transparent;
  color: #9aa3ad;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}
.exam-btn-secondary:hover { border-color: #48D1CC; color: #48D1CC; }

/* ── Skeletons ── */
.exam-skeleton {
  border-radius: 12px;
  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);
  background-size: 200% 100%;
  animation: examSkeleton 1.4s ease infinite;
}

.exam-skel-header   { width: 100%; height: 72px; border-radius: 16px; }
.exam-skel-progress { width: 100%; height: 72px; border-radius: 16px; }
.exam-skel-question { width: 100%; height: 140px; border-radius: 16px; }

@keyframes examSkeleton {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .exam-title { font-size: 20px; }
  .exam-btn-submit { width: 100%; }
  .exam-submit-bar { align-items: stretch; }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Certifications/Exam/Exam.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,4BAA4B;AAC9B;AACA,mBAAmB,cAAc,EAAE;;AAEnC,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;EACrD,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;AACA,yBAAyB,oCAAoC,EAAE,cAAc,EAAE;;AAE/E;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;AACA,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;;AAEhE,qBAAqB;AACrB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;AACA,4BAA4B,qBAAqB,EAAE,cAAc,EAAE;;AAEnE,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yEAAyE;EACzE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA,sBAAsB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACtE,sBAAsB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACtE,sBAAsB,WAAW,EAAE,aAAa,EAAE,mBAAmB,EAAE;;AAEvE;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,qBAAqB;AACrB;EACE,cAAc,eAAe,EAAE;EAC/B,mBAAmB,WAAW,EAAE;EAChC,mBAAmB,oBAAoB,EAAE;AAC3C","sourcesContent":["/* ── Page wrapper ── */\n.exam-page {\n  display: flex;\n  justify-content: center;\n  padding: 24px 16px 64px;\n  min-height: 100%;\n}\n\n.exam-container {\n  width: 100%;\n  max-width: 720px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Back button ── */\n.exam-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: #9aa3ad;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0;\n  width: fit-content;\n  transition: color 0.15s ease;\n}\n.exam-back:hover { color: #48D1CC; }\n\n/* ── Header ── */\n.exam-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.exam-header-icon-wrap {\n  width: 56px;\n  height: 56px;\n  min-width: 56px;\n  border-radius: 16px;\n  background: rgba(59, 179, 174, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.exam-header-icon {\n  color: #48D1CC !important;\n  font-size: 28px !important;\n}\n\n.exam-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.exam-subtitle {\n  margin: 4px 0 0;\n  font-size: 14px;\n  color: #9aa3ad;\n}\n\n/* ── Progress card ── */\n.exam-progress-card {\n  background: #0e1b1b;\n  border-radius: 16px;\n  border: 1px solid #484848;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.exam-progress-top {\n  display: flex;\n  justify-content: space-between;\n}\n\n.exam-progress-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #e6eaef;\n}\n\n.exam-progress-count {\n  font-size: 14px;\n  font-weight: 700;\n  color: #48D1CC;\n}\n\n.exam-progress-track {\n  width: 100%;\n  height: 8px;\n  border-radius: 99px;\n  background: #071414;\n  overflow: hidden;\n}\n\n.exam-progress-fill {\n  height: 100%;\n  border-radius: 99px;\n  background: linear-gradient(90deg, #3BB3AE, #48D1CC);\n}\n\n/* ── Questions list ── */\n.exam-questions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* ── Question card ── */\n.exam-question-card {\n  background: #0e1b1b;\n  border-radius: 16px;\n  border: 1px solid #484848;\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.exam-question-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.exam-q-num {\n  min-width: 32px;\n  height: 26px;\n  border-radius: 8px;\n  background: rgba(59, 179, 174, 0.15);\n  color: #48D1CC;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.exam-q-text {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e6eaef;\n  line-height: 1.5;\n}\n\n/* ── Options ── */\n.exam-options-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.exam-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #071414;\n  border: 1.5px solid #484848;\n  border-radius: 12px;\n  padding: 12px 14px;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.exam-option:hover:not(:disabled) {\n  border-color: rgba(59,179,174,0.35);\n  background: #071414;\n}\n\n.exam-option:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.exam-option-selected {\n  border-color: #3BB3AE !important;\n  background: rgba(59, 179, 174, 0.1) !important;\n}\n\n.exam-option-icon {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.exam-option-text {\n  flex: 1;\n  font-size: 14px;\n  color: #c5cdd6;\n  line-height: 1.45;\n}\n\n.exam-option-check {\n  color: #3BB3AE !important;\n  font-size: 18px !important;\n  flex-shrink: 0;\n}\n\n/* ── Submit bar ── */\n.exam-submit-bar {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.exam-submit-hint {\n  margin: 0;\n  font-size: 13px;\n  color: #9aa3ad;\n}\n\n.exam-btn-submit {\n  padding: 12px 36px;\n  border-radius: 12px;\n  border: none;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  background: linear-gradient(135deg, #3BB3AE, #0099a8);\n  color: #fff;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.exam-btn-submit:not(:disabled):hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.exam-btn-submit:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ── Dialog buttons ── */\n.exam-btn-cancel {\n  padding: 9px 20px;\n  border-radius: 10px;\n  border: 1px solid #484848;\n  background: transparent;\n  color: #9aa3ad;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease;\n}\n.exam-btn-cancel:hover { border-color: rgba(255,255,255,0.25); color: #e6eaef; }\n\n.exam-btn-confirm {\n  padding: 9px 24px;\n  border-radius: 10px;\n  border: none;\n  background: linear-gradient(135deg, #3BB3AE, #0099a8);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n.exam-btn-confirm:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ── Error card ── */\n.exam-error-card {\n  background: #0e1b1b;\n  border-radius: 16px;\n  border: 1px solid rgba(239, 83, 80, 0.2);\n  padding: 40px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: #9aa3ad;\n  text-align: center;\n}\n\n.exam-btn-secondary {\n  margin-top: 8px;\n  padding: 10px 24px;\n  border-radius: 12px;\n  border: 1px solid #484848;\n  background: transparent;\n  color: #9aa3ad;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease;\n}\n.exam-btn-secondary:hover { border-color: #48D1CC; color: #48D1CC; }\n\n/* ── Skeletons ── */\n.exam-skeleton {\n  border-radius: 12px;\n  background: linear-gradient(90deg, #0e1b1b 25%, #132828 50%, #0e1b1b 75%);\n  background-size: 200% 100%;\n  animation: examSkeleton 1.4s ease infinite;\n}\n\n.exam-skel-header   { width: 100%; height: 72px; border-radius: 16px; }\n.exam-skel-progress { width: 100%; height: 72px; border-radius: 16px; }\n.exam-skel-question { width: 100%; height: 140px; border-radius: 16px; }\n\n@keyframes examSkeleton {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n  .exam-title { font-size: 20px; }\n  .exam-btn-submit { width: 100%; }\n  .exam-submit-bar { align-items: stretch; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
